import { render, staticRenderFns } from "./_Files.vue?vue&type=template&id=0d6d469c&"
import script from "./_Files.vue?vue&type=script&lang=ts&"
export * from "./_Files.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports